import { actionTypes } from '../actions/sms.action'

const initialState = {
    code: '',
    screen_id: null,
    open: false,
    error: {}
}

const smsReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.CHANGE:
        return { 
            ...state,
            ...payload
        }

    case actionTypes.SUCCESS:
        return { 
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default smsReducer